import { Component } from '@angular/core';
import { LoadingController, NavController, NavParams } from 'ionic-angular';
import { DetailPage } from '../detail/detail';
import { SearchService } from '../../providers/search';
import { FavoriteExternPage } from '../favorite-extern/favorite-extern';
import { ErrorHandling } from '../../shared/error.handling';

@Component({
    selector: 'page-favorite',
    templateUrl: 'favorite.html'
})
export class FavoritePage {

    favorites: any = [];
    favStructure: any = [];
    favFolder: any = [];
    favDocument: any = [];
    favAddress: any = [];
    favMeeting: any = [];
    loader;
    structCounter: number = 0;

    constructor(public navCtrl: NavController,
                public navParams: NavParams,
                public loadingCtrl: LoadingController,
                public searchService: SearchService,
                public errorHandling: ErrorHandling) {
        this.loader = this.loadingCtrl.create();
        this.loader.present();
    }

    /** Calls getFavorites method */
    ionViewDidEnter() {
        this.getFavorites();
    }

    /** Gets details */
    getDetails(id, type) {
        this.navCtrl.push(DetailPage, {'objId': id, 'orgaStruct': type});
    }

    /** Loads favorites from localStorage */
    getFavorites() {
        let favorites = JSON.parse(localStorage.getItem('favorites'));

        this.favStructure = favorites.filter((fav) => {
            return fav.orgaStruct === 'Structure';
        });

        this.favFolder = favorites.filter((fav) => {
            return fav.orgaStruct === 'Folder';
        });

        this.favDocument = favorites.filter((fav) => {
            return fav.orgaStruct === 'Document';
        });

        this.favAddress = favorites.filter((fav) => {
            return fav.orgaStruct === 'Address';
        });

        this.favMeeting = favorites.filter((fav) => {
            return fav.orgaStruct === 'Meeting';
        });

        this.favorites = [].concat(this.favStructure, this.favFolder, this.favDocument, this.favAddress, this.favMeeting);
        this.loader.dismiss();
    }

    /** Loads external favorites*/
    extFavorites() {
        // reset counter add external favs
        this.structCounter = 0;
        localStorage.setItem('extfavorites', JSON.stringify([]));

        this.loader = this.loadingCtrl.create({content: 'Lade externe Favoriten ...'});
        this.loader.present();
        this.getExternalFavourites();
    }

    /**
     * Loads external favorites from server
     * @param {string} orgaStructure
     */
    getExternalFavourites() {
        this.searchService.externalFavourites().subscribe(
            (success) => {
                this.loader.dismiss();
                this.navCtrl.push(FavoriteExternPage, {favourites: success}, {animate: true, direction: 'foreward'})
            }, (error) => {
                this.loader.dismiss();
                console.error('getExternalFavourites Error: ', error);
            }
        )
    }
}



// WEBPACK FOOTER //
// ./src/pages/favorite/favorite.ts